import _ from 'lodash'

class UserRole {
  constructor() {}

  static factory($resource, config) {
    return $resource(
      config.roleResourcePath,
      {userId: '@userId'},
      {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    )
  }
}

UserRole.factory.$inject = ['$resource', 'config']

export default UserRole
